/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class GisDatastoreService extends services.DataService<Wars.Domain.Model.Gis.GisDatastore> {

        constructor(injectedBreeze: typeof breeze, $q: angular.IQService, private $http: angular.IHttpService) {
            super(injectedBreeze, $q);
        }

        public createGeometryDatastoreType(): Wars.Domain.Model.Gis.GeometryDatastoreType {
            return this.createNewEntity<Wars.Domain.Model.Gis.GeometryDatastoreType>("GeometryDatastoreType");
        }

        public createGisDatastore(): Wars.Domain.Model.Gis.GisDatastore {
            return this.createNewEntity<Wars.Domain.Model.Gis.GisDatastore>("GisDatastore");
        }

        public getGisDatastores(): ng.IPromise<Wars.Domain.Model.Gis.GisDatastore[]> {
            const query = this.breezeModule.EntityQuery
                .from("GisDatastores")
                .expand("availableDatastoreTypes");

            return this.executeQuery(query);
        }

        public activate(gisDatastoreId): angular.IPromise<any> {
            let d = this.$q.defer();

            this.$http.post('./api/GisDatastore/' + gisDatastoreId + '/Activate', null).then(r => {
                d.resolve();
            });

            return d.promise;
        }

        public queryGisDatastore(gisDatastore: Wars.Domain.Model.Gis.GisDatastore,
            placeholderValueDictionary: any,queryConfiguration:Wars.Domain.Model.Gis.GisDatastoreQueryConfiguration, geometryPlaceholder?: any): angular.IPromise<any>  {
            let d = this.$q.defer();

            let geoJson = null;
            if (geometryPlaceholder && geometryPlaceholder.type) {
                geoJson = geometryPlaceholder;
            }
            else if (geometryPlaceholder) {
                geoJson = geometryPlaceholder.toGeoJSON();
            }

           /* if (queryConfiguration) {
                if (!placeholderValueDictionary) {
                    placeholderValueDictionary = {};
                }

                queryConfiguration.wherePredicates.forEach(f => {
                    let value = "";
                    if (f.value) {
                        value = f.value;
                    }

                   if (!f.isPlaceholder) {
                       placeholderValueDictionary[`Metadata${f.metadataNumber}`] = value;
                   }
                });
            }*/

            let data = {
                geoJson:geoJson,
                placeHolders:placeholderValueDictionary
            };


            this.$http.post(`api/GisDatastore/${gisDatastore.id}/Query/${queryConfiguration.id}`, data).then(f => {
                d.resolve(f.data);
            });

            return d.promise;
        }
    }
}

warsApp.registerService('GisDatastoreService', ['breeze', '$q', '$http']);